import { $padding_lg } from '../pebbleGlobalToken/spacing.js';

/**
 * 卡片-控制元素的大内间距
 * @description enDesc: -
 * @description type: Space
 * @description value: $padding_lg
 */
var $card_padding_lg = $padding_lg;

export { $card_padding_lg };
